import { type CSSProperties } from 'react';
import { IListItem } from '../../interfaces'
import '../styles/ListItem.css';
import '../../utils/GlobalStyles.css';
import Text from '../main/Text';
import Icon from '../main/Icon';
import { getTranslatedLabel, getProtocolUrl } from '../../utils/translations';

const icons = 
{
    'Cell telephone number': <Icon icon = 'phone'/>,
    'Work telephone number': <Icon icon = 'phone' />,
    'Email': <Icon icon = 'envelope' />,
    'WhatsApp': <Icon icon = 'whatsapp' size = '28px'/>,
    'Facebook Messenger': <Icon icon = 'facebook' size = '25px' />,
    'LinkedIn': <Icon icon = 'linkedin' size = '25px' />,
    'Google Business Message': <Icon icon = 'google' size = '23px'/>,
    'Website': <Icon icon = 'desktop'/>
}

function ListItem({ title, value }: IListItem)
{
    const translatedTitle = getTranslatedLabel(title);
    const protocolUrl = getProtocolUrl(title, value);
    
    // Hide value text for WhatsApp, Facebook and LinkedIn completely
    const displayValue = (title === 'WhatsApp' || title === 'Facebook Messenger' || title === 'LinkedIn') 
        ? ''
        : value;

    const handleClick = () => {
        // Open WhatsApp, Facebook, LinkedIn, and Website links in new window/tab
        if (title === 'WhatsApp' || title === 'Facebook Messenger' || title === 'LinkedIn' || title === 'Website') {
            window.open(protocolUrl, '_blank');
        } else {
            window.open(protocolUrl, '_self');
        }
    };

    return (
        <div
            className = 'data-container shadow list-item-clickable'
            style = {{ '--item-hover': sessionStorage.getItem('primaryColor') as string } as CSSProperties}
            onClick={handleClick}
        >
            <div style = {{ paddingRight: '15px'}}>
                <Text text = {translatedTitle} fontSize = {16} fontWeight = {700}/>
                <Text text = {displayValue} fontSize={16} fontWeight={300} />
            </div>

            {Object(icons)[title]}
        </div>
    )
}

export default ListItem